import React from 'react';
import PropTypes from 'prop-types';

import TicketFormFields from './TicketFormFields';

import { Divider } from '@mui/material';

const TicketEditor = ({event, onEventChange, setUnsavedChanges}) => {

  // const [open, setOpen] = useState(false);
  const { session_tickets } = event;

  const handleChange = (e, index) => {
    setUnsavedChanges(true)
    const { name, value } = e.target
    const newTickets = [...session_tickets]
    newTickets[index][name] = value
    let newEvent = { ...event, session_tickets: newTickets };
    onEventChange(newEvent)
  };

  const handleDelete = (index) => {
    setUnsavedChanges(true)
    const newTickets = [...session_tickets]
    newTickets.splice(index, 1)
    let newEvent = { ...event, session_tickets: newTickets }
    onEventChange(newEvent)
  };

  const showDivider = (index) => (session_tickets.length > 1 && index !== session_tickets.length - 1)

  return (
    <div className="event-form-ticket_editor">
      
      {session_tickets.map((ticket, index) => (
        <div key={index}>
          <TicketFormFields
            ticket={ticket}
            onChange={(e) => handleChange(e, index)}
            showDelete={true}
            onDelete={() => handleDelete(index)}
          />

          {showDivider(index) && 
            <Divider light sx={{marginBottom: 2}} />
          }
        </div>
      ))}
    </div>
  );
};

TicketEditor.propTypes = {
    event: PropTypes.object,
    onEventChange: PropTypes.func,
    setUnsavedChanges: PropTypes.func
};

export default TicketEditor;